export const ONLINE_USERS_STREAM_STARTED = "onlineUsers/STREAM_STARTED";
export const ONLINE_USERS_STREAM_STOPPED = "onlineUsers/STREAM_STOPPED";

export const ONLINE_USERS_INITIAL = "onlineUsers/INITIAL";
export const ONLINE_USERS_UPDATE = "onlineUsers/UPDATE";
export const ONLINE_USERS_ADD_OR_UPDATE = "onlineUsers/ADD_OR_UPDATE";
export const ONLINE_USERS_REMOVE = "onlineUsers/REMOVE";
